import { RecordSummaryTrendSeriesDto } from './record-summary-trend-series.dto';

export class RecordSummaryTrendDto {
  from!: Date | null;
  to!: Date | null;
  points!: number;
  trendBucketDurationMilliseconds!: number;
  series!: RecordSummaryTrendSeriesDto[];
}
